export default __webpack_public_path__ + "static/media/flash17.150d3da6.png";